module.exports = __webpack_public_path__ + "static/media/close-icon.63ebc4c3.svg";